import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import responsiveStyles from "./responsiveStyles.module.scss";
import { Wrapper } from "../../reusable";
import { CardStack } from "../../ui/card-stack";

function WhatWereDoing() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkMobile();

    // Add event listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const steps = [
    {
      step: "01",
      title: "Initial assessment",
      body: "We review your medication history and adverse effects to determine claim eligibility.",
    },
    {
      step: "02",
      title: "Medical review",
      body: "Our medical experts analyze your case and gather supporting evidence for your claim.",
    },
    {
      step: "03",
      title: "Claim & resolution",
      body: "We pursue compensation for harm suffered. You don't pay unless we win.",
    },
    {
      step: "04",
      title: "Ongoing support",
      body: "We provide continuous guidance throughout the process and keep you updated on progress.",
    },
  ];

  const cards = [
    {
      id: 1,
      name: "Initial assessment",
      designation: "Step 01",
      content: (
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Initial assessment
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            We review your medication history and adverse effects to determine
            claim eligibility.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      name: "Medical review",
      designation: "Step 02",
      content: (
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Medical review
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            Our medical experts analyze your case and gather supporting evidence
            for your claim.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      name: "Claim & resolution",
      designation: "Step 03",
      content: (
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Claim & resolution
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            We pursue compensation for harm suffered. You don't pay unless we
            win.
          </p>
        </div>
      ),
    },
    {
      id: 4,
      name: "Ongoing support",
      designation: "Step 04",
      content: (
        <div>
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "8px",
              color: "#2c3e50",
            }}
          >
            Ongoing support
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#476072",
              margin: 0,
            }}
          >
            We provide continuous guidance throughout the process and keep you
            updated on progress.
          </p>
        </div>
      ),
    },
  ];

  return (
    <section className={`${styles.section} ${responsiveStyles.section}`}>
      <Wrapper>
        <div className={`${styles.inner} ${responsiveStyles.inner}`}>
          <h2>What we're doing</h2>

          {/* Desktop: Show original timeline layout */}
          <div
            className={`${styles.timeline} ${responsiveStyles.timeline}`}
            style={{ display: isMobile ? "none" : "grid" }}
          >
            {steps.map((s, i) => (
              <div className={styles.step} key={i}>
                <div className={styles.badge}>{s.step}</div>
                <div className={styles.content}>
                  <h3>{s.title}</h3>
                  <p>{s.body}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile: Show CardStack */}
          {isMobile && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginTop: "40px",
              }}
            >
              <CardStack items={cards} offset={15} scaleFactor={0.08} />
            </div>
          )}
        </div>
      </Wrapper>
    </section>
  );
}

export default WhatWereDoing;
